import { POLL_RESPONSE_FILTER_ALL } from '@/components/reporting/poll-response-report-filter-values'

export interface PollResponseReportFilters {
  search: string
  pollId: string
  schoolId: string
  classId: string
  dateFrom: string
  dateTo: string
  questionType: string
  status: string
}

export function hasPollResponseReportFilters(
  filters: PollResponseReportFilters,
  emptyValue = POLL_RESPONSE_FILTER_ALL,
): boolean {
  return (
    filters.search.trim() !== '' ||
    filters.pollId !== emptyValue ||
    filters.schoolId !== emptyValue ||
    filters.classId !== emptyValue ||
    filters.dateFrom !== '' ||
    filters.dateTo !== '' ||
    filters.questionType !== emptyValue ||
    filters.status !== emptyValue
  )
}
